module.exports = "../../static/img/banner2.jpg?c3144d7";


//////////////////
// WEBPACK FOOTER
// ./pc/index/assets/img/banner2.jpg
// module id = 798
// module chunks = 9